import {
  PdfGen,
  PdfUnit,
  PdfSize,
  PdfRect,
  PdfPoint,
  PdfBrush,
  PdfColor,
  PdfImage,
} from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { IItemCount } from '@educraft/base';
import { OptsImage } from '../optsImage';
import { GUtil } from '../../pdf/gutil';
import { placeObjects } from '../../core/placeObjects';

/**
 * Vpravo_vlevo (Right/Left) - Normal and flipped image pairs
 *
 * Layout: Multiple portrait pages, each with randomly placed images.
 * Some images are normal, some are horizontally flipped.
 * Students count how many face left vs right.
 *
 * Migrated from C# EduFrame.Img10.Generators.Vpravo_vlevo
 */
export class VpravoVlevo implements ILayoutImageGen, IItemCount {
  private flippedCache = new Map<number, PdfImage>();

  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 1;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    this.flippedCache.clear();

    const margin = PdfUnit.FromMillimeters(15);
    const top = PdfUnit.FromMillimeters(50);
    const imageSize = new PdfSize(PdfUnit.FromMillimeters(40), PdfUnit.FromMillimeters(40));
    const rectSize = new PdfSize(PdfUnit.FromMillimeters(25), PdfUnit.FromMillimeters(35));

    const containerRect = new PdfRect(
      margin,
      margin + top,
      PdfSize.A4.width - 2 * margin,
      PdfSize.A4.height - 2 * margin - top
    );

    const a1 = new PdfRect(
      PdfSize.A4.width / 2 - margin - rectSize.width,
      margin,
      rectSize.width,
      PdfUnit.FromMillimeters(10)
    );
    const a2 = new PdfRect(
      PdfSize.A4.width / 2 + margin,
      margin,
      rectSize.width,
      PdfUnit.FromMillimeters(10)
    );

    const r1 = new PdfRect(a1.x, a1.bottom, rectSize.width, rectSize.height);
    const r2 = new PdfRect(a2.x, a2.bottom, rectSize.width, rectSize.height);

    const darkBlueBrush = new PdfBrush(PdfColor.fromRgb(0, 0, 139));
    const {random} = opts.data;
    const pageCount = opts.list.length;

    for (let pageIdx = 0; pageIdx < pageCount; pageIdx++) {
      const page = pdf.addPage();

      const normalCount = 2 + random.next(0, 5);
      const flippedCount = 2 + random.next(0, 5);
      const objs: boolean[] = [];
      for (let i = 0; i < normalCount; i++) objs.push(false);
      for (let i = 0; i < flippedCount; i++) objs.push(true);

      const placed = placeObjects(random, containerRect, imageSize, objs);

      page.drawArrowLeft(a1, darkBlueBrush);
      page.drawArrowRight(a2, darkBlueBrush);
      page.drawRectangle(GUtil.basePen, null, r1);
      page.drawRectangle(GUtil.basePen, null, r2);

      let flippedImg = this.flippedCache.get(pageIdx);
      if (!flippedImg && opts.list[pageIdx].image) {
        flippedImg = await opts.list[pageIdx].image.flipH(pdf);
        this.flippedCache.set(pageIdx, flippedImg);
      }

      for (const obj of placed) {
        if (obj.data) {
          page.drawImageCenter(flippedImg ?? opts.list[pageIdx].image, obj.rect);
        } else {
          page.drawImageCenter(opts.list[pageIdx].image, obj.rect);
        }
      }
    }
  }
}
